import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const PrematureNewborns = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Recém-Nascidos Prematuros'}
            indicatorValue={chartData?.indicators?.prematureNewborns}
            className='aligned-container'
        />
    );
};
